import { DateString, dateStringSerializer } from "@megaron/date-string";
import { isUuid, Uuid } from "@megaron/uuid";

import { MegaraxUri } from "../uri";

type SegmentParam<TSegment extends string> = TSegment extends `:${infer Param}` ? Param : never;

type PathParamNames<TPath extends string> = TPath extends `${infer Head}/${infer Rest}`
  ? SegmentParam<Head> | PathParamNames<Rest>
  : SegmentParam<TPath>;

type PathParams<TPath extends string> = { [K in PathParamNames<TPath>]: string };

export type LegacyPathParams = Record<string, string>;

export type LegacyRedirect = {
  legacyPath: string;
  toUri: (params: LegacyPathParams) => MegaraxUri | undefined;
};

export const uuidParam = (value: string): Uuid | undefined => (isUuid(value) ? value : undefined);

export const dateParam = (value: string): DateString | undefined => {
  const result = dateStringSerializer.deserialize(value);
  return result.isOk ? result.value : undefined;
};

export const redirect = <TPath extends string>(
  legacyPath: TPath,
  toUri: (params: PathParams<TPath>) => MegaraxUri | undefined,
): LegacyRedirect => ({ legacyPath, toUri: toUri as LegacyRedirect["toUri"] });
